import { render, staticRenderFns } from "./ProdutosFornecedor.vue?vue&type=template&id=a3a10fae"
import script from "./ProdutosFornecedor.vue?vue&type=script&lang=js"
export * from "./ProdutosFornecedor.vue?vue&type=script&lang=js"
import style0 from "./ProdutosFornecedor.vue?vue&type=style&index=0&id=a3a10fae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports